// Footer.js
import React from 'react';
import config from '../Configs/Config';

const Footer = () => {
  return (
    <footer className="footer">
      <p className='mb2'>&copy; 2025 {config.siteName}. All rights reserved.</p>
      <p className='mb2'>Registered with Election Commission of India.</p>
      <p className='mb2'> Reg. No: {config.partyRegNos}</p>
    </footer>
  );
};

export default Footer;